import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MemberShipGradeApi } from 'api';
import type { MemberShipGrade } from 'api/methods/MemberShipGradeApi';

/**
 * [MemberShipGrade] Query key 생성
 * --
 */
export const memberShipGradeQueryKeys = createQueryKeys('memberShipGrade', {
  getMemberShipGrade: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getMemberShipGrades: (params?: { [key: string]: string | number }) => [
    params,
  ],
});

/**
 * [MemberShipGrade] 등급내역 전체 조회
 * --
 */
export const useGetMemberShipGrades = (
  params?: {
    [key: string]: string | number;
  },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: memberShipGradeQueryKeys.getMemberShipGrades(params).queryKey,
    queryFn: () => MemberShipGradeApi.getMemberShipGrades(params),
    ...options,
  });
  return data;
};

/**
 * [MemberShipGrade] 등급내역 상세 조회
 * --
 */
export const useGetMemberShipGrade = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: memberShipGradeQueryKeys.getMemberShipGrade(idx, params).queryKey,
    queryFn: () => MemberShipGradeApi.getMemberShipGrade(idx, params),
  });

  return data;
};

/**
 * [MemberShipGrade] 등급내역 생성
 * --
 */
export const useCreateMemberShipGrade = () => {
  const { mutateAsync: createMemberShipGrade, ...result } = useMutation({
    mutationFn: (variables: MemberShipGrade) =>
      MemberShipGradeApi.createMemberShipGrade(variables),
  });

  return { createMemberShipGrade, ...result };
};

/**
 * [MemberShipGrade] 등급내역 수정
 * --
 */
export const useUpdateMemberShipGrade = (body: MemberShipGrade) => {
  const { mutateAsync: updateMemberShipGrade, ...result } = useMutation({
    mutationFn: (variables: MemberShipGrade) =>
      MemberShipGradeApi.updateMemberShipGrade(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateMemberShipGrade, ...result };
};

/**
 * [MemberShipGrade] 등급내역 삭제
 * --
 */
export const useDeleteMemberShipGrade = (idx: number) => {
  const { mutateAsync: deleteMemberShipGrade, ...result } = useMutation({
    mutationFn: (variables: number) =>
      MemberShipGradeApi.deleteMemberShipGrade(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteMemberShipGrade, ...result };
};
